import React from 'react';
import { connect } from 'react-redux';
import { MdCheckCircle } from 'react-icons/md';
import s from './style.css';
import CircleProgress from '../CircleProgress';
import FileLabel from '../FileLabel';
const UploadItem = (props) => {
    const { file, progress, uri } = props;
    return (React.createElement("div", { className: s.itemContainer },
        React.createElement("div", { className: s.infoContainer },
            file.isPhoto ? (React.createElement("img", { src: uri, className: s.img, style: { opacity: progress === 1 ? 1 : 0.5 } })) : (React.createElement(FileLabel, { file: file, small: true })),
            React.createElement("p", { className: s.fileName }, file.name)),
        progress === 1 ? (React.createElement(MdCheckCircle, { size: 24, className: s.checkCircle })) : (React.createElement(CircleProgress, { progress: progress, size: 24, strokeWidth: 3 }))));
};
const mapStateToProps = (state, ownProps) => ({
    uri: state.vaultCache[ownProps.file.previewUriKey] ? state.vaultCache[ownProps.file.previewUriKey].uri : null,
    progress: state.upload[ownProps.file.uriKey],
});
const connector = connect(mapStateToProps);
export default connector(UploadItem);
